import { Pipe, PipeTransform } from '@angular/core';
import {
  RemoteServiceDiagnosisEntry,
  RemoteServiceDiagnosisTag,
} from 'src/app/@store/remote-service/remote-service.model';

@Pipe({
  name: 'hasBetaInternalTags',
  standalone: true,
})
export class HasBetaInternalTagsPipe implements PipeTransform {
  transform(entry: RemoteServiceDiagnosisEntry): { beta: boolean; internal: boolean } {
    if (!entry || !entry.tags || entry.tags.length === 0) {
      return null;
    }

    const beta = entry.tags.includes(RemoteServiceDiagnosisTag.Beta);
    const internal = entry.tags.includes(RemoteServiceDiagnosisTag.InternalRsa);

    if (!beta && !internal) {
      return null;
    }

    return {
      beta,
      internal,
    };
  }
}
